import i18n from 'i18next'
import { TYPE } from './defConstants'
import MailboxObj from './MailboxObj'
import type { MailboxData } from './MailboxObj'
import dataManager from './DataManager'
import forge from 'node-forge'

export class SpamSniperMailbox extends MailboxObj {
  _listType: any
  encInfo: any

  constructor(dataMgr: any, options: any) {
    super(dataMgr)
    this.data = {
      id: options.id,
      role: options.role,
      name: options.name,
      parentId: options.parentId,
    }

    this._listType = TYPE.EMAIL
    this.isRealMailbox = false
    this.isEmailType = true

    this.encInfo = {
      key: '!@#$%jiran123456!@#$%jiran123456',
      iv: '!@#$%jiraniv1234',
    }
  }

  getSortInfo = () => {
    return {
      type: 'sort_date',
      direction: 'sort_desc',
    }
  }

  getReqState = () => {
    return 0
  }

  setLimit = (limit: number) => {
    console.log('setLimit', limit)
  }

  applyData = (data: any) => {
    console.log('applyData', data)
    return false
  }

  getId = () => this.data.id
  getRole = () => this.data.role
  getDisplayName = () => {
    const role = this.getRole()
    /* i18next-extract-disable-next-line */
    return i18n.t(`mailbox.displayName.${role}`)
  }
  getFullName = () => this.getDisplayName()

  getViewCountInfo = (): { count: number | null; type: string } | null => {
    return null
  }

  isSelected = (): boolean => {
    return false
  }

  onClick = (e: any, runCommand: any) => {
    console.log(' -- onClick : ', e)
    const userInfo = dataManager.getUserInfo()
    if (userInfo != null) {
      const { email } = userInfo
      const encryptedEmail = this.getEncryptedEmail(email)
      const url = this.getUrl(encryptedEmail)

      console.log(' -- encryptedEmail : ', encryptedEmail)
      console.log(' -- spam sniper url : ', url)

      window.open(url, '_blank')

      // 링크가 열리면, 인증 메일이 발송되므로 10초 후 메일을 읽어오도록 처리.
      setTimeout(() => {
        runCommand('sync')
      }, 10000)
    }
  }

  getUrl = (encryptedEmail: string) => {
    return `https://spam.jiran.com/mail/set_opt.php?email=${encryptedEmail}&opt=index`
  }

  getEncryptedEmail = (email: string) => {
    const { key, iv } = this.encInfo
    const cipher = forge.cipher.createCipher('AES-CBC', key)
    cipher.start({ iv: iv })
    cipher.update(forge.util.createBuffer(email))
    cipher.finish()
    const encrypted = cipher.output
    // outputs encrypted hex
    const ret = encrypted.toHex().toUpperCase()
    return ret
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  setRole = (role: any) => {}
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  rename = (newName: any) => {}
  getParentMailbox = (): any => null
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  isContain = (email: any): boolean => {
    return false
  }
  getEmailDeleteType = (): string => {
    return 'destroy'
  }
  getToolbarMode = (): string => {
    return ''
  }

  getEmailById = (id: any): any => {
    const email = this.emailListForEmail.find((item) => {
      return item.data.id === id
    })
    return email
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  changeParent = (newParentId: any) => {}

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  delete = (deleteEmails?: boolean) => {
    // 메일 박스 삭제 불가.
    return null
  }
  // 메일박스 하위 메일박스 삭제. (deleteSelf: 자신 메일박스 삭제 여부)
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  deleteChild = (deleteSelf?: boolean) => {
    // 메일 박스 하위 메일박스 삭제 불가. - 하위 메일박스 불가능.
    return null
  }
  // 이메일 삭제.
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  deleteEmails = async (emailList: any) => {
    return Promise.resolve(null)
  }
  // 하위 폴더 가능 여부
  childEnabled = (): boolean => {
    // 메일 박스 하위 폴더 불가능.
    return false
  }

  getListType = () => this._listType
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  notifyCountChanged = (count: any) => {}
  getResultFilter = () => () => false

  resetData = () => {}

  resetReqData = () => {}

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  getThreadById = (id: any) => {
    return null
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  setEmailSearch = (text: string | null) => {}

  getAllData = (): MailboxData => {
    return null
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  reqNextThreadList = (offset?: number, info?: any, dataInfo?: any, needTotal?: boolean) => {
    return Promise.resolve(null)
  }

  reqUpdatedThreadData = (_isSave?: any) => {
    return Promise.resolve(null)
  }

  updateData = async (): Promise<any> => {
    return Promise.resolve(null)
  }

  getThreadEmailfilter = () => {
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    const threadEmailfilter = (emailObj: any) => {
      return true
    }
    return threadEmailfilter
  }

  isMoveEnabled = () => {
    return false
  }

  isSentMailbox = (): boolean => {
    return false
  }
}

const spamSniperMap = {
  mailbox: SpamSniperMailbox,
}

export default spamSniperMap
